import { createContext } from 'react';

const LocaleContext = createContext();

export const { Provider, Consumer } = LocaleContext;

export default LocaleContext;
